import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "喵喵喵喵喵~",
          "meow meow~ =^_^=",
          "にゃんにゃん",
          "miaou miaou",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
